import { Directive, Input } from "@angular/core";

@Directive({
    selector: '[appIsLoading]',
    exportAs: 'appIsLoading'
})
export class IsLoadingDirective {
    @Input() appIsLoading: any;
}